import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: remCalc(8),
        },
        label: {
            width: 'fit-content',
            alignItems: 'center',
            marginLeft: remCalc(0),
            textStyle: 'body-small',
            color: 'text.default',
        },
        control: {
            width: 'iconsSize.medium',
            height: 'iconsSize.medium',
            borderColor: 'border.dark',
            border: 'small',
            borderStyle: 'solid',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            bg: 'none',
            _checked: {
                bg: 'none',
                borderColor: 'border.dark',
            },
            _hover: {
                bg: 'none',
                borderColor: 'border.dark',
                _checked: {
                    bg: 'none',
                    borderColor: 'border.dark',
                },
            },
        },
        icon: {
            color: 'black',
            _checked: {
                color: 'black',
            },
            _hover: {
                bg: 'none',
                borderColor: 'border.dark',
                _checked: {
                    bg: 'none',
                    borderColor: 'border.dark',
                },
            },
        },
    },
    variants: {
        row: {
            container: {
                flexDirection: 'row',
            },
        },
    },
    defaultProps: {
        size: 'none',
    },
}
